import {WalletModalForm} from './WalletModalForm'

const WalletModalFormWrapper = ({openTopUpWalletModal, setOpenTopUpWalletModal, getUser, user, pointsHistoryList}) => {
    return <WalletModalForm openTopUpWalletModal={openTopUpWalletModal}setOpenTopUpWalletModal={setOpenTopUpWalletModal} getUser={getUser} user={user} pointsHistoryList={pointsHistoryList} />
}

export {WalletModalFormWrapper}
